import { EcpLocator } from '../ecp-locator-new';
import { Wiki } from '../wiki';
import { SignUpBanner } from '../sign-up-banner';
import { WhyMyAcuvue } from '../why-my-acuvue';
import { PrimaryBannerUnregistered } from '../primary-banner-unregistered';
import { DownloadApp } from '../../download-app';
import { useStyles } from './landing-page-not-logged-in.styles';
import { Separator } from '../../../../common';
import { Simulator } from '../simulator';

export const LandingPageNotLoggedIn = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <SignUpBanner />
      <DownloadApp />
      <Separator />
      <WhyMyAcuvue />
      <PrimaryBannerUnregistered />
      <EcpLocator />
      {process.env?.REACT_APP_IS_SIMULATOR === 'true' && (
        <div className={classes.simulator}>
          <Simulator />
        </div>
      )}
      <div className={classes.coloredSection}>
        <Wiki />
      </div>
    </>
  );
};
